<div class="global-header">
    <div class="global-header__main">
        <div class="global-header__left">
            <div class="global-header__flag">
                <img ngSrc="images/india-flag.svg" alt="menu" fill />
            </div>
            <p>{{ 'governmentOfIndia' | translate }}</p>
        </div>
        <div class="global-header__right">
            <div class="global-header__font-switcher">
                <button
                    type="button"
                    class="global-header__font-btn"
                    [ngClass]="{ 'global-header__font-btn--active': activeButton() === 'decrease' }"
                    (click)="changeFontSize('decrease')"
                >
                    A<sup>-</sup>
                </button>
                <button
                    type="button"
                    class="global-header__font-btn"
                    [ngClass]="{ 'global-header__font-btn--active': activeButton() === 'reset' }"
                    (click)="changeFontSize('reset')"
                >
                    A
                </button>
                <button
                    type="button"
                    class="global-header__font-btn"
                    [ngClass]="{ 'global-header__font-btn--active': activeButton() === 'increase' }"
                    (click)="changeFontSize('increase')"
                >
                    A<sup>+</sup>
                </button>
            </div>

            <div class="global-header__theme-switcher">
                @if (theme() === 'dark') {
                    <div class="global-header__theme-icon">
                        <img
                            ngSrc="images/moon.svg"
                            alt="moon"
                            fill
                            (click)="setTheme('light')"
                            (keydown.enter)="setTheme('light')"
                            (keydown.space)="setTheme('light'); $event.preventDefault()"
                            tabindex="0"
                            role="button"
                        />
                    </div>
                }
                @if (theme() === 'light') {
                    <div class="global-header__theme-icon">
                        <img
                            ngSrc="images/sun.svg"
                            alt="sun"
                            fill
                            (click)="setTheme('dark')"
                            (keydown.enter)="setTheme('dark')"
                            (keydown.space)="setTheme('dark'); $event.preventDefault()"
                            tabindex="0"
                            role="button"
                        />
                    </div>
                }
            </div>

            <div class="global-header__lang-switcher" [matMenuTriggerFor]="langMenu">
                <div class="global-header__lang-icon">
                    <img ngSrc="images/language.svg" alt="globe" fill />
                </div>
                <p>{{ selectedLanguage().translation }}</p>
                <div class="global-header__lang-arrow">
                    <img ngSrc="images/chevron-down.svg" alt="arrow" fill />
                </div>

                <mat-menu #langMenu="matMenu" class="mat-elevation-z3" xPosition="before">
                    @for (lang of appLanguages; track $index) {
                        <button mat-menu-item class="global-header__lang-menu-btn" (click)="onLanguageChange(lang)">
                            <span class="global-header__lang-text">
                                {{ lang.translation }}
                                @if (lang.langCode !== 'en') {
                                    ({{ lang.langName }})
                                }
                            </span>
                            @if (lang.langCode === selectedLanguage().langCode) {
                                <img
                                    [ngSrc]="theme() === 'dark' ? 'images/check-white.svg' : 'images/check.svg'"
                                    alt="check"
                                    width="14"
                                    height="10"
                                    class="global-header__lang-check"
                                />
                            }
                        </button>
                    }
                </mat-menu>
            </div>
        </div>
    </div>
</div>
